// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"7d306b98","845":"aee42cab"}[chunkId] + ".chunk.js";
};